import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { SeoService } from '../../../../service/seo.service';
import { NavigationEnd, Router } from '@angular/router';
import { UrlcanonicaService } from '../../../../service/urlcanonica.service';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { LicitacionService } from '../../../../service/licitacion.service';
import { UbicacionesService } from '../../../../service/ubicaciones.service';

@Component({
  selector: 'app-postulanteslicitacion',
  templateUrl: './postulanteslicitacion.component.html',
  styleUrls: ['./postulanteslicitacion.component.css']
})
export class PostulanteslicitacionComponent implements OnInit {
	private subscription: Subscription = new Subscription();
	RouteText : any;
	tituloseo: any;
	urlcanonicaseo: any;
	imagenseo: any;
	keywordsseo: any;
	descripcionseo: any;
	toggle:boolean = true;
	estatusUpdate: any;
	CaliidUpda: any;
	calificacionUpdate: any;
	formupdate: any;
	principal = true;
	provedore = false;
	editar = false;
	success= false;
	fail = false;
	isReadonly=false;
	addd = false;
	ofertas!: any[];
	familias!: any[];
	calificaciones!: any [];
	
	parfiltros:any;
	codigoProductoUpdate:any;
	productoUpdate:any;
	familiaUpdate:any;
	mensajeTextAreaUpdate:any;
	p: number = 1;
	urlPdf: any;
	proveedorList!: any[];
	idprovedormod: any;

	idestado: any;
	idMunicipio: any;
	estados: any;
	ciudades: any;
	succes = false;
	calle!: string;
	colonia!: string;
	apellidoPaterno!: string;
	apellidoMaterno!: string;
	email!: string;
	cp!: string;
	giro!: string;
	nExterior!: string;
	nInterior!: string;
	nombreContacto!: string;
	razonSocial!: string;
	referencia!: string;
	rfcescrito!: string;
	telefonoFijo: any;
	telefonoMovil: any;
	
	urlcvEmpresarial!: string;
	urldomicilio!: string;
	urlsituacionFiscal!: string;
	urlestadoCuenta!: string;
	urlRFC!: string;
	urlIne!: string;
	urlImss!: string;
	urlFoto!: string;
	urlOpinion!: string;
	dataprovedor = false;
	showcomm = false;
	idproducto: any;
	calificacionselect: any;
  ///////

	constructor( 
		private meta: Meta,
		private title: Title,
		private _seoService: SeoService,
		private router: Router,
		private _licitacionservice: LicitacionService,
		private _ubicacionesService: UbicacionesService,
		private _urlcanonicaservice: UrlcanonicaService
		) { 
			if((sessionStorage.getItem('token') == null || sessionStorage.getItem('token') == 'null')||(sessionStorage.getItem('user') == null || sessionStorage.getItem('user') == 'null')){
				this.router.navigate(['/licitaciones/administrador/login']);
			}
			this.router.events.pipe(filter((event: any) =>  event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
				this.RouteText = event;
				this.getSEO(event.url)
			});
		}

	getSEO(page: string) {
		this._seoService.getSEO(page).subscribe((resp: any) => {
			this.tituloseo = resp.titulo;
			this.descripcionseo = resp.descripcion;
			this.urlcanonicaseo = resp.urlcanonica;
			this.imagenseo = resp.image;
		
			this._urlcanonicaservice.createCanonicalLink();
			this.title.setTitle(this.tituloseo)
			this.meta.updateTag({name: 'description',content: this.descripcionseo})
			this.meta.updateTag({property: 'twitter:card',content: 'summary'})
			this.meta.updateTag({property: 'twitter:site',content: '@fundacionbest'})
			this.meta.updateTag({property: 'twitter:title',content: 'Fundación BEST'})
			this.meta.updateTag({property: 'twitter:description',content: this.descripcionseo})
			this.meta.updateTag({property: 'twitter:image',content: this.imagenseo})
			this.meta.updateTag({property: 'og:url',content: 'https://fundacionbest.org.mx/licitaciones/login'})
			this.meta.updateTag({property: 'og:title',content: this.tituloseo})
			this.meta.updateTag({property: 'og:image',content: this.imagenseo})
			this.meta.updateTag({property: 'og:description',content: this.descripcionseo})
		});
	}

	ngOnInit(): void {
		this.getEstado();
		this.getFamilias();
		this.getOfertas();
	}

	gopro(){
		this.principal = true;
		this.provedore= false;
	}

	addOferta(){this.addd = true;}
	
	getEstado(){
		this.subscription.add(
			this._ubicacionesService.getEstados().subscribe((resp: any) => {
				this.estados = resp;
			})
		);
	}

	getOfertas() {
        this.subscription.add(
            this._licitacionservice.getOfertas(sessionStorage.getItem('token')).subscribe((resp: any) => {
				this.ofertas = resp;
            })
        );
    }

	getFamilias() {
        this.subscription.add(
            this._licitacionservice.getFamiliaIntere().subscribe((resp: any) => {
				this.familias = resp;
            })
        );
    }

	pdfInput(event: any) {
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            if (file.size < 5000000) {
                if (!/(pdf)$/ig.test(file.type)) {
                    alert("Invalid file type: "+file.type+".  Please use DOC, PDF or Zip.");
                }else{
                    this._licitacionservice.UploadImage(file).subscribe((resp: any) => {
                        this.urlPdf = resp.substr(2);
                    });
                }
            } else {
                alert("Invalid file size: "+file.size+".  Please use file to size 5MB");
            }
        }
    }

	getCalificacion(){
		this.subscription.add(
            this._licitacionservice.calificacionesadmin().subscribe((resp: any) => {
				
				this.calificaciones = resp;
            })
        );
	}

	confirmacionAgregar(form: NgForm) {
		var insert = {
			Codigo : form.value.CodigoProducto,
			Producto : form.value.Producto,                              
			UrlFichaTecnica : this.urlPdf,
			DetalleOferta : form.value.DetalleOferta,
			Idfamilia : form.value.FamiliaId,
		
		}
		this.subscription.add(
            this._licitacionservice.postInsertProducto(insert, sessionStorage.getItem('token') ).subscribe((resp: any) => {
				form.reset();
				this.addd = false;
				this.getOfertas();
            })
        );
		
	}

	change(calificacion?: any){
		
		if(calificacion == undefined || calificacion == 'undefined'){
			calificacion = this.calificacionselect;
		}else{
			this.calificacionselect = calificacion;
		}

		this.idproducto = calificacion.id;
		this.productoUpdate = calificacion.producto;
		this.familiaUpdate = calificacion.familia;
		this.principal = false;
		this.provedore=true;
		this.dataprovedor= false;
		this.subscription.add(
			
			this._licitacionservice.GetProvedoresbyId(calificacion.id, sessionStorage.getItem('token')).subscribe((resp: any) => {
				this.proveedorList = resp
			})
		);
	}
	
	getcommentario(id: number) {
        console.log(id)
		if(id == 5){
			this.showcomm = true;
		}else{
			this.showcomm = false;
		}
    }

	detalle(alldata: any){
		
		this.subscription.add(
			this._licitacionservice.GetProveedor(alldata.rfc,sessionStorage.getItem('token')).subscribe((resp: any) => {
				this.idprovedormod = resp.id;
				this.idestado = resp.idestado;
				this.idMunicipio = resp.idciudad;       
				this.getCiudades(this.idestado);        
				this.apellidoMaterno = resp.paterno;
				this.apellidoPaterno = resp.materno;
				this.calle = resp.calle;
				this.colonia = resp.colonia;
				this.email = resp.correo;
				this.cp = resp.cp;
				this.giro = resp.giro;
				this.nExterior = resp.nexterior;
				this.nInterior = resp.ninterior;
				this.nombreContacto = resp.nombre;
				this.razonSocial = resp.razonSocial;
				this.referencia = resp.referencia;
				this.rfcescrito = resp.rfc;
				this.telefonoFijo = resp.telefonoFijo;
				this.telefonoMovil = resp.telefonoMovil;

				this.urlcvEmpresarial= resp.urlCvempresarial;
				this.urldomicilio= resp.urlCompDomFiscal;
				this.urlsituacionFiscal=resp.urlCompSitFiscal;
				this.urlestadoCuenta= resp.urlEstadoCuenta;
				this.urlRFC= resp.urlRfc;
				this.urlIne= resp.urlIne;
				this.urlImss= resp.urlImss;
				this.urlFoto= resp.urlFotoFachada;
				this.urlOpinion= resp.urlOpinionCumplimiento;
				
				this.principal = false;
				this.provedore=false;
				this.dataprovedor= true;
				
			})
		);
	}

	getCiudades(estadoId: number) {
		this.subscription.add(
			this._ubicacionesService.getCiudades(estadoId).subscribe((resp: any) => {
				this.ciudades = resp;
			})
		);
	}

	cancel() {
		this.editar = false;
		this.addd = false;
	}

	evaluar(){
		this.getCalificacion();
		this.editar = true;
		this.idprovedormod

	}

	UpdateCalifo(form: NgForm) {
		this.formupdate = form.value;
		this.success= true;
		this.editar = false;
	}

	closeok() {
		if(this.formupdate.comentarios == null || this.formupdate.comentarios == 'null'){this.formupdate.comentarios = "ninguno"}
		var post = {
			Idproveedor: this.idprovedormod,
			Idcalificacion : this.formupdate.calificacionUpdate,
			Idproducto: this.idproducto,
			Comentarios: this.formupdate.comentarios
		}

		this.subscription.add(
            this._licitacionservice.postUpdateprogreso(post, sessionStorage.getItem('token') ).subscribe((resp: any) => {
				this.success= false;
				this.editar = false;
				this.change();
            })
        );
	}

	closefail() {
		this.success= false;
		this.editar = true;
	}
}